module.exports = __webpack_public_path__ + "media/images/sp/specials/common/special_c_10-8d47e379d36e6b5f2075de39d0bf5c99.jpg";